import React, { useState, useEffect } from "react";
import { CalculatePercentage } from "./CalculatePercentage";

function CascadeComponent({ months, filter }) {
	const [isNegative, setIsNegative] = useState(false);
	const [percentage, setPercentage] = useState("0%");
	useEffect(() => {
		let data = CalculatePercentage(
			"Mixed Paper/Fiber",
			"wasteTotal",
			months,
			filter,
			"Rigids      (refundable & non)"
		);
		setIsNegative(data[0]);
		setPercentage(data[1]);
	}, [isNegative, months, filter]);

	return (
		<>
			<div className="flex">
				<div className={isNegative ? "positive" : "negative"}></div>
			</div>
			<p className="percent-text">
				<span className="arrow">{isNegative ? "↓" : "↑"}</span>
				{percentage}
			</p>
		</>
	);
}

export default CascadeComponent;
